import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { GetStorageItem } from "../helpers/Functions";
import { AuthenticationConstans } from "../Constants";
import { GetUserRoles } from "../helpers/Functions";

export default function ProtectedRoute(props: any) {
  const userIdentity = GetStorageItem(AuthenticationConstans.Identity);
  const location = useLocation();
  if (userIdentity === null) {
    return <Navigate to="/Login" state={{ from: location }} replace />
  }
  const hasAccess: boolean = (props.roles && props.roles !== undefined) ? props.roles!.some((role: any) => GetUserRoles().includes(role)) : true;
  if (!hasAccess)
    return (<div style={{ textAlign: "center", paddingTop: 10 }}><h2 className="error">You don't have access to this page</h2></div>);
  return props.component;
}